import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import Login from "../components/login/login";
// import { appMount, appOutdated, appReload } from '../actions';
import login from "../actions/login";
import dataLoad from "../actions/data-load";
import subscribeNotifications, { subscribeWithExistingPermission } from "../actions/firebase-notifications";

function mapStateToProps(state) {
  return {
    app: state.app,
    user: state.user,
    ajaxStatuses: state.ajaxStatuses,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      subscribeNotifications,
      subscribeWithExistingPermission,
      login,
      dataLoad,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);
